import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '@/views/Home.vue'
import Sources from '@/data/sources';
import Metric from '@/types/metric'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
];

// Import routes for all metrics
Sources.forEach((x:Metric) => {
    routes.push({
      path: `/${x.category}/${x.topic}`,
      name: x.topic,
      component: () => import(`../views/${x.category}/${x.topic}.vue`)
    }) 
});

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  const matchingSource = Sources.find(source => source.topic === to.name);
  if (matchingSource) {
    document.title = matchingSource.source;
  } else {
    document.title = to.name?.toString() ?? 'MiEconomy';
  }
  return next();
})

export default router
